import { fetchCustomerContacts } from 'actions/customerContacts';
import { fetchIntegrationSettings } from 'actions/integrationSettings';
import CustomerContactsCard from 'components/CustomerContacts/CustomerContactsCard';
import IntegrationSettingsCard from 'components/CustomerImport/EditIntegrationSettings/IntegrationSettingsCard';
import LinkLookup from 'components/LinkLookup';
import LoadingIndicator from 'components/LoadingIndicator';
import Navbar from 'components/Navbar';
import SettingSidebar from 'components/Navbar/SettingsSidebar';
import Permissions from 'components/Permissions';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getCustomerContractsLoading,
  getUpsertCustomerContractLoading,
} from 'selectors/customerContracts';
import { NAV_BAR_HEIGHT_REM } from 'utils/dimensions';
import ContractsList from './CustomerContractsList';

const CustomerContractsManager: React.FC = () => {
  const dispatch = useDispatch();
  const fetchLoading = useSelector(getCustomerContractsLoading);
  const upsertLoading = useSelector(getUpsertCustomerContractLoading);

  useEffect(() => {
    dispatch(fetchCustomerContacts());
    dispatch(fetchIntegrationSettings());
  }, [dispatch]);

  const warningBarOffset =
    document != null &&
    document.getElementById != null &&
    document.getElementById('customer-warning')?.offsetHeight;

  return (
    <div
      className="min-w-screen bg-white"
      style={{
        height: `calc(100vh - ${warningBarOffset}px)`,
      }}
    >
      <Navbar />
      <div
        className="flex flex-row"
        style={{
          height: `calc(100vh - ${warningBarOffset}px - ${NAV_BAR_HEIGHT_REM}rem)`,
        }}
      >
        <SettingSidebar />
        <div className="pl-5 pr-6 pt-16 pb-6 flex flex-col gap-6 h-full overflow-hidden">
          <header>
            <div className="flex flex-row justify-between items-center">
              <div className="flex flex-row items-center">
                <h1 className="text-heading-1">Account Overview</h1>
                {(upsertLoading || fetchLoading) && <LoadingIndicator className="ml-2" size="5" />}
              </div>
              <Permissions action="analytics.list">
                <LinkLookup
                  routeName="antitrust-assessment"
                  className="button button--primary h-10 px-6 font-bold justify-center"
                  data-testid="generate-assessment-button"
                >
                  Generate Assessment
                </LinkLookup>
              </Permissions>
            </div>
          </header>
          <div className="flex flex-row gap-6">
            <CustomerContactsCard />
            <IntegrationSettingsCard />
          </div>
          <main className="flex h-full overflow-hidden">
            <ContractsList />
          </main>
        </div>
      </div>
    </div>
  );
};

export default CustomerContractsManager;
